import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getStoredLocale, resolveLocaleForRedirect } from '../../util/locale';

/**
 * Handles bare `/` — redirects to `/{locale}` from stored preference, else
 * browser language, else English.
 * Preserves query string and hash (e.g. `/?pub_categoryLevel1=yoga`).
 */
const RootLocaleRedirect = () => {
  const location = useLocation();
  const currentUser = useSelector(state => state.user?.currentUser);
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const locale = resolveLocaleForRedirect({
    storedLocale: getStoredLocale(),
    profileLocale: isAuthenticated ? currentUser?.attributes?.profile?.privateData?.locale : null,
  });
  return <Redirect to={`/${locale}${location.search || ''}${location.hash || ''}`} />;
};

export default RootLocaleRedirect;
